import { render, staticRenderFns } from "./EnquiryChoicesComponent.vue?vue&type=template&id=14455a53"
import script from "./EnquiryChoicesComponent.vue?vue&type=script&lang=ts"
export * from "./EnquiryChoicesComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports